// extracted by mini-css-extract-plugin
export default {"main":"status_main__HVxce","all":"status_all__gOT1t","box":"status_box__BrDvq","triangleright":"status_triangleright__4fotN"};